export const BOOLEAN_NUMBER = {
  0: 'No',
  1: 'Yes',
};

export const BOOLEAN_NUMBER_LIST = Object.entries(BOOLEAN_NUMBER).map(([id, name]) => ({id, name}));
